export const WAREHOUSE_VALIDATION_SCHEMA = {
  name: {
    required: 'Name is required',
  },
  party_name: {
    required: 'Party Name is required',
  },
  inventory_available: {
    required: 'Status is required',
  },
  gstin: {
    required: 'GSTIN is required',
  },
};

export const PO_ADDRESS_VALIDATION_SCHEMA = {
  name: {
    required: 'Authorised Person is required',
  },
};
